import { FormFieldBase } from './form-field-base';

export class FormFieldMultiselect extends FormFieldBase<string> {
  controlType = 'multiselect';
  options: {key: string, value: string}[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}
